const BASE_URL = "https://buildhaven.onrender.com";

export default BASE_URL;
